import {finish, error} from '../../../modules/betslip/actions/get-possible-bets';

import api from '../../../api';

let _lastRequestId = 0;
const requestDecorator = (requestFn) => (...args) => requestFn(++_lastRequestId, ...args);

export const request = requestDecorator((_requestId, dispatch, {userId, bets, selectedLegs, channel, selections, isFreeBet, selectedFreeBets}) => {
    bets = bets.filter(bet => bet.stakePerLine);

    bets.forEach(bet => {
        bet.stakePerLine = Math.round(100 * bet.stakePerLine);

        bet.legs.forEach(leg => {
            leg.type = leg.type || 'standard';
            leg.marketId = parseInt(leg.marketId, 10);

            if (typeof leg.price === 'string') {
                leg.price = {f: leg.price};
            }

            if (leg.type === 'empty') {
                leg.eventName = leg.eventName || 'Event name';
                leg.selectionName = leg.selectionName || 'Selection name';
            }

            /*if (leg.price && leg.price.f !== selections.getIn([ leg.selectionId, 'price', 'f' ])) {
                leg.ignore = [ 'Selection:price:decreased', 'Selection:price:increased' ];
            }*/
        });
    });

    selectedLegs.forEach(leg => {
        leg.type = leg.type || 'standard';
        leg.marketId = parseInt(leg.marketId, 10);

        if (typeof leg.price === 'string') {
            leg.price = {f: leg.price};
        }

        if (leg.type === 'empty') {
            leg.eventName = leg.eventName || 'Event name';
            leg.selectionName = leg.selectionName || 'Selection name';
        }

        /*if (leg.price && leg.price.f !== selections.getIn([ leg.selectionId, 'price', 'f' ])) {
            leg.ignore = [ 'Selection:price:decreased', 'Selection:price:increased' ];
        }*/
    });

    api.post('/betslip/possible-bets', {
        accountId: userId,
        selectedLegs,
        bets,
        channel,
        isFreeBet,
        selectedFreeBets
    }, {cache: true}).then(
        data => {
            if (_lastRequestId === _requestId) {
                return dispatch(finish(userId, data));
            }
        },
        err => {
            if (_lastRequestId === _requestId) {
                return dispatch(error(userId, err.errors || (typeof err === 'string' ? {program: err} : err)))
            }
        }
    );
});
